// extracted by mini-css-extract-plugin
module.exports = {"actionsPopUp":"ActionPopUp_actionsPopUp__3khNr","actionsPopUp__header":"ActionPopUp_actionsPopUp__header__3LOhk","actionsPopUp__body":"ActionPopUp_actionsPopUp__body__2vCZd"};